var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-recaptcha',{attrs:{"sitekey":"6Le6Yh0UAAAAAAIXpmakytZapEhClcoswljficew"},on:{"verify":_vm.recaptchaVerified}})
}
var staticRenderFns = []

export { render, staticRenderFns }